import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import { LinearProgress } from "@mui/material";
import { FaCalendar, FaCheckCircle, FaSuitcase, FaUser } from "react-icons/fa";

function SingleProjectComponent({ projectData }) {
  return (
    <div className="shadow-lg">
      <div className="flex bg-blue-50/80 rounded-t-lg justify-between items-center p-5">
        <section>
          <h1 className="text-[25px] font-medium text-left w-full">
            {projectData?.name}
          </h1>
        </section>
        <section className="flex gap-5 items-center">
          {projectData?.status === "Initiated" ? (
            <section className="bg-blue-100 py-1 px-5 w-fit rounded-full text-blue-600 font-medium text-center">
              Initiated
            </section>
          ) : projectData?.status === "In Progress" ? (
            <section className="bg-slate-100 py-1 px-5 w-fit rounded-full text-slate-600 font-medium text-center">
              In Progress
            </section>
          ) : projectData?.status === "On Hold" ? (
            <section className="bg-yellow-100 py-1 px-5 w-fit rounded-full text-yellow-600 font-medium text-center">
              Hold
            </section>
          ) : projectData?.status === "Completed" ? (
            <section className="bg-green-100 py-1 px-5 w-fit rounded-full text-green-600 font-medium text-center">
              Completed
            </section>
          ) : (
            <section className="bg-red-100 py-1 px-5 w-fit rounded-full text-red-600 font-medium text-center">
              Closed
            </section>
          )}
        </section>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-2 gap-5">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaCalendar className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Started On
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {new Date(projectData?.startDate).toDateString("en-In")}
              </p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaCalendar className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Deadline
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {new Date(projectData?.deadline).toDateString("en-In")}
              </p>
            </div>
          </div>
          {projectData?.manager?.fullName && (
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <FaUser className="h-6 w-6 text-gray-500" />
              </div>
              <div className="ml-3">
                <h3 className="text-[15px] font-medium text-gray-500">
                  Manager
                </h3>
                <p className="mt-1 text-[16px] text-gray-900">
                  {projectData?.manager?.fullName}
                </p>
              </div>
            </div>
          )}
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaCheckCircle className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Total Employees
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {projectData?.totalEmployees}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 space-y-5">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaSuitcase className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Description
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {projectData?.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SingleProjectPage() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (employeeData !== null && employeeData?.admin === undefined) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const { projectId } = useParams();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [reload, setReload] = useState(false);
  const [projectData, setProjectData] = useState(undefined);

  // fetch single project
  async function getProject() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/projects/get/single/${projectId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setProjectData(res.data?.data || null);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Hiring request fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getProject();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex items-center justify-center">
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Project Details
          </h1>
          <div className="mt-5">
            <SingleProjectComponent projectData={projectData} />
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleProjectPage;
